import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Available theme options for the application
 * - 'light': Light theme
 * - 'dark': Dark theme
 * - 'system': Follows system preference
 */
type Theme = 'light' | 'dark' | 'system'

/**
 * Theme store interface
 * Defines the shape of our theme store state and actions
 */
interface ThemeStore {
  /** Current selected theme */
  theme: Theme
  /** Action to update the theme */
  setTheme: (theme: Theme) => void
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      theme: 'system', // Default to system preference
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: 'theme-storage', // localStorage key
    },
  ),
)
